<template>
	<div style="position:relative;">
	<div class="content">
		<div class="tip">
			<span>发票信息</span>
		</div>
		<van-form ref="form">
      <van-field v-if="method === 'add'" v-model="billData.typeName" name="发票类别" label="发票类别" placeholder="发票类别"
                 :rules="[{ required: true, message: '请选择发票类别' }]" readonly @click="showPicker = true"
      />
			<div v-if="type == 'vat_invoice'">
				<van-field v-model="billData.purchaserName" name="购买方名称" label="购买方名称" placeholder="购买方名称"
					:rules="[{ required: true, message: '请填写购买方名称' }]"
				/>
				<van-field v-model="billData.purchaserRegisterNum" name="购买方税号" label="购买方税号" placeholder="购买方税号"
					:rules="[{ required: true, message: '请填写购买方税号' }]"
				/>
				<van-field v-model="billData.sellerName" name="销售方名称" label="销售方名称" placeholder="销售方名称" autosize
					 type="textarea"
					:rules="[{ required: true, message: '请填写销售方名称' }]"
				/>
				<van-field v-model="billData.sellerRegisterNum" name="销售方税号" label="销售方税号" placeholder="销售方税号"
					:rules="[{ required: true, message: '请填写销售方税号' }]"
				/>
				<van-field v-model="billData.invoiceType" name="发票类型" label="发票类型" placeholder="发票类型"
					:rules="[{ required: true, message: '请填写发票类型' }]"
				/>
				<van-field v-model="billData.invoiceCode" name="发票代码" label="发票代码" placeholder="发票代码"
				/>
				<van-field v-model="billData.invoiceNum" name="发票号码" label="发票号码" placeholder="发票号码"
					:rules="[{ required: true, message: '请填写发票号码' }]"
				/>
				<van-field v-model="billData.totalTax"  @input="checkAmount('vat_invoice',billData.totalTax,billData.totalAmount,billData.amountInFiguers)" name="合计税额" label="合计税额" placeholder="合计税额"
					:rules="[{ required: true, message: '请填写合计税额' }]"
				/>
				<van-field v-model="billData.totalAmount" @input="checkAmount('vat_invoice',billData.totalTax,billData.totalAmount,billData.amountInFiguers)" name="合计金额" label="合计金额" placeholder="合计金额"
					:rules="[{ required: true, message: '请填写合计金额' }]"
				/>
				<van-field v-model="billData.amountInFiguers" @input="checkAmount('vat_invoice',billData.totalTax,billData.totalAmount,billData.amountInFiguers)" name="价税合计(小写)" label="价税合计(小写)" placeholder="价税合计(小写)"
							 :rules="[{ required: true, message: '请填写价税合计(小写)' }]"
				/>
				<van-field v-model="billData.amountInWords" name="价税合计(大写)" label="价税合计(大写)" placeholder="价税合计(大写)"
							 :rules="[{ required: true, message: '请填写价税合计(大写)' }]"
				 />
				<van-field v-model="billData.invoiceDate" name="开票日期" label="开票日期" placeholder="开票日期"
							 :rules="[{ required: true, message: '请填写开票日期' }]"
				/>
				<van-field v-model="billData.checkCode" name="校验码" label="校验码" placeholder="校验码"/>
				<div class="tip">
					<div>发票明细</div>
          <van-button v-show="method === 'add'" icon="plus" type="info" size="small" @click="addDetail"></van-button>
				</div>
				<div class="list" v-for="(item,index) in billDetails" :key="index" @click="handerDetail(index,billDetails,billData.status,billData.ischeck)">
					<span class="item span">{{item.name}}</span>
					<div class="item-line"></div>
				</div>
			</div>
			<div v-if="type == 'taxi_receipt'">
				<van-field v-model="billData.invoiceCode" name="发票代码" label="发票代码" placeholder="发票代码"
				/>
				<van-field v-model="billData.invoiceNum" name="发票号码" label="发票号码" placeholder="发票号码"
					:rules="[{ required: true, message: '请填写发票号码' }]"
				/>
				<van-field v-model="billData.taxiNum" name="车牌号" label="车牌号" placeholder="车牌号"
				/>
				<van-field v-model="billData.date" name="日期" label="日期" placeholder="日期"
					:rules="[{ required: true, message: '请填写日期' }]"
				/>
				<van-field v-model="billData.time" name="上下车时间" label="上下车时间" placeholder="上下车时间"
					:rules="[{ required: true, message: '请填写上下车时间' }]"
				/>
				<van-field v-model="billData.pickupTime" name="上车时间" label="上车时间" placeholder="上车时间"
                   :rules="[{ required: true, message: '请填写上车时间' }]"
				/>
				<van-field v-model="billData.dropoffTime" name="下车时间" label="下车时间" placeholder="下车时间"
                   :rules="[{ required: true, message: '请填写下车时间' }]"
				/>
				<van-field v-model="billData.fare" name="金额" label="金额" type="number" placeholder="金额" :formatter="formatterNumber" format-trigger="onBlur"
					:rules="[{ required: true, message: '请填写金额' }]"
				/>
				<van-field v-model="billData.fuelOilDurcharge" name="燃油附加费" type="number" label="燃油附加费" placeholder="燃油附加费" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写燃油附加费' }]"
				/>
				<van-field v-model="billData.callDerviceDurcharge" name="叫车服务费" type="number" label="叫车服务费" placeholder="叫车服务费" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写叫车服务费' }]"
				/>
				<van-field v-model="billData.totalFare" name="总金额" label="总金额" type="number" placeholder="总金额" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写总金额' }]"
				/>
				<van-field v-model="billData.location" name="开票城市" label="开票城市" placeholder="开票城市"
					:rules="[{ required: true, message: '请填写开票城市' }]"
				/>
				<van-field v-model="billData.province" name="省" label="省" placeholder="省"
					:rules="[{ required: true, message: '请填写省' }]"
				/>
				<van-field v-model="billData.city" name="市" label="市" placeholder="市"
					:rules="[{ required: true, message: '请填写市' }]"
				/>
				<van-field v-model="billData.pricePerkm" name="单价" label="单价" placeholder="单价" type="number" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写单价' }]"
				/>
				<van-field v-model="billData.distance" name="里程" label="里程" placeholder="里程" type="number" :formatter="formatterNumber" format-trigger="onBlur"
					:rules="[{ required: true, message: '请填写里程' }]"
				/>
			</div>
			<div v-if="type == 'train_ticket'">
				<van-field v-model="billData.ticketNum" name="车票号" label="车票号" placeholder="车票号"
					:rules="[{ required: true, message: '请填写车票号' }]"
				/>
				<van-field v-model="billData.startingStation" name="始发站" label="始发站" placeholder="始发站"
					:rules="[{ required: true, message: '请填写始发站' }]"
				/>
				<van-field v-model="billData.destinationStation" name="到达站" label="到达站" placeholder="到达站"
					:rules="[{ required: true, message: '请填写到达站' }]"
				/>
				<van-field v-model="billData.trainNum" name="车次号" label="车次号" placeholder="车次号"
					:rules="[{ required: true, message: '请填写车次号' }]"
				/>
				<van-field v-model="billData.date" name="出发日期" label="出发日期" placeholder="出发日期"
					:rules="[{ required: true, message: '请填写出发日期' }]"
				/>
				<van-field v-model="billData.ticketRates" name="车票金额" label="车票金额" placeholder="车票金额" type="number" :formatter="formatterNumber" format-trigger="onBlur"
					:rules="[{ required: true, message: '请填写车票金额' }]"
				/>
				<van-field v-model="billData.seatCategory" name="席别" label="席别" placeholder="席别"
					:rules="[{ required: true, message: '请填写席别' }]"
				/>
				<van-field v-model="billData.name" name="乘客姓名" label="乘客姓名" placeholder="乘客姓名"
					:rules="[{ required: true, message: '请填写乘客姓名' }]"
				/>
				<van-field v-model="billData.idCard" name="身份证号" label="身份证号" placeholder="身份证号"
					:rules="[{ required: true, message: '请填写身份证号' }]"
				/>
				<van-field v-model="billData.serialNumber" name="序列号" label="序列号" placeholder="序列号"
					:rules="[{ required: true, message: '请填写序列号' }]"
				/>
				<van-field v-model="billData.waitingArea" name="售站" label="售站" placeholder="售站"
					:rules="[{ required: true, message: '请填写售站' }]"
				/>
				<van-field v-model="billData.time" name="时间" label="时间" placeholder="时间"
					:rules="[{ required: true, message: '请填写时间' }]"
				/>
				<van-field v-model="billData.seatNum" name="座位号" label="座位号" placeholder="座位号"
					:rules="[{ required: true, message: '请填写座位号' }]"
				/>
			</div>
			<div v-if="type == 'quota_invoice'">
				<van-field v-model="billData.invoiceCode" name="发票代码" label="发票代码" placeholder="发票代码"
					:rules="[{ required: true, message: '请填写发票代码' }]"
				/>
				<van-field v-model="billData.invoiceNum" name="发票号码" label="发票号码" placeholder="发票号码"
					:rules="[{ required: true, message: '请填写发票号码' }]"
				/>
				<van-field v-model="billData.invoiceRate" name="金额" label="金额" placeholder="金额"
					:rules="[{ required: true, message: '请填写金额' }]"
				/>
				<van-field v-model="billData.invoiceRateInFigure" name="金额小写" label="金额小写" placeholder="金额小写" type="number" :formatter="formatterNumber" format-trigger="onBlur"
					:rules="[{ required: true, message: '请填写金额小写' }]" @change="changeAmount"
				/>
				<van-field v-model="billData.invoiceRateInWord" name="金额大写" label="金额大写" placeholder="金额大写"
					:rules="[{ required: true, message: '请填写金额大写' }]"
				/>
				<van-field v-model="billData.province" name="省" label="省" placeholder="省"
					:rules="[{ required: true, message: '请填写省' }]"
				/>
				<van-field v-model="billData.city" name="市" label="市" placeholder="市"
					:rules="[{ required: true, message: '请填写市' }]"
				/>
				<van-field v-model="billData.location" name="发票所在地" label="发票所在地" placeholder="发票所在地"
					:rules="[{ required: true, message: '请填写发票所在地' }]"
				/>
			</div>
			<div v-if="type == 'air_ticket'">
				<van-field v-model="billData.name" name="姓名" label="姓名" placeholder="姓名"
					:rules="[{ required: true, message: '请填写姓名' }]"
				/>
				<van-field v-model="billData.startingStation" name="始发站" label="始发站" placeholder="始发站"
					:rules="[{ required: true, message: '请填写始发站' }]"
				/>
				<van-field v-model="billData.destinationStation" name="目的站" label="目的站" placeholder="目的站"
					:rules="[{ required: true, message: '请填写目的站' }]"
				/>
				<van-field v-model="billData.flight" name="航班号" label="航班号" placeholder="航班号"
					:rules="[{ required: true, message: '请填写航班号' }]"
				/>
				<van-field v-model="billData.date" name="日期" label="日期" placeholder="日期"
					:rules="[{ required: true, message: '请填写日期' }]"
				/>
				<van-field v-model="billData.ticketNumber" name="电子客票号码" label="电子客票号码" placeholder="电子客票号码"
					:rules="[{ required: true, message: '请填写电子客票号码' }]"
				/>
				<van-field v-model="billData.fare" name="票价" label="票价" placeholder="票价" type="number" :formatter="formatterNumber" format-trigger="onBlur"
					:rules="[{ required: true, message: '请填写票价' }]"
				/>
				<van-field v-model="billData.devFund" name="民航发展基金/基建费" label="民航发展基金/基建费" placeholder="民航发展基金/基建费" type="number" :formatter="formatterNumber" format-trigger="onBlur"
					:rules="[{ required: true, message: '请填写民航发展基金/基建费' }]"
				/>
				<van-field v-model="billData.oilMoney" name="燃油附加费" label="燃油附加费" placeholder="燃油附加费" type="number" :formatter="formatterNumber" format-trigger="onBlur"
					:rules="[{ required: true, message: '请填写燃油附加费' }]"
				/>
				<van-field v-model="billData.otherTax" name="其他税费" label="其他税费" placeholder="其他税费" type="number" :formatter="formatterNumber" format-trigger="onBlur"
					:rules="[{ required: true, message: '请填写其他税费' }]"
				/>
				<van-field v-model="billData.ticketRates" name="合计金额" label="合计金额" placeholder="合计金额" type="number" :formatter="formatterNumber" format-trigger="onBlur"
					:rules="[{ required: true, message: '请填写合计金额' }]"
				/>
				<van-field v-model="billData.startDate" name="填开日期" label="填开日期" placeholder="填开日期"
					:rules="[{ required: true, message: '请填写填开日期' }]"
				/>
				<van-field v-model="billData.idCard" name="身份证号" label="身份证号" placeholder="身份证号"
					:rules="[{ required: true, message: '请填写身份证号' }]"
				/>
				<van-field v-model="billData.carrier" name="承运人" label="承运人" placeholder="承运人"
					:rules="[{ required: true, message: '请填写承运人' }]"
				/>
				<van-field v-model="billData.time" name="时间" label="时间" placeholder="时间"
					:rules="[{ required: true, message: '请填写时间' }]"
				/>
				<van-field v-model="billData.issuedBy" name="订票渠道" label="订票渠道" placeholder="订票渠道"
					:rules="[{ required: true, message: '请填写订票渠道' }]"
				/>
				<van-field v-model="billData.serialNumber" name="印刷序号" label="印刷序号" placeholder="印刷序号"
					:rules="[{ required: true, message: '请填写印刷序号' }]"
				/>
				<van-field v-model="billData.insurance" name="保险费" label="保险费" placeholder="保险费" type="number" :formatter="formatterNumber" format-trigger="onBlur"
					:rules="[{ required: true, message: '请填写保险费' }]"
				/>
				<van-field v-model="billData.fareBasis" name="客票级别" label="客票级别" placeholder="客票级别"
					:rules="[{ required: true, message: '请填写客票级别' }]"
				/>
				<van-field v-model="billData.level" name="座位等级" label="座位等级" placeholder="座位等级"
					:rules="[{ required: true, message: '请填写座位等级' }]"
				/>
				<van-field v-model="billData.agentCode" name="销售单位号" label="销售单位号" placeholder="销售单位号"
					:rules="[{ required: true, message: '请填写销售单位号' }]"
				/>
				<van-field v-model="billData.endorsement" name="签注" label="签注" placeholder="签注"
					:rules="[{ required: true, message: '请填写签注' }]"
				/>
				<van-field v-model="billData.allow" name="免费行李" label="免费行李" placeholder="免费行李"
					:rules="[{ required: true, message: '请填写免费行李' }]"
				/>
				<van-field v-model="billData.ck" name="验证码" label="验证码" placeholder="验证码"/>
			</div>
			<div v-if="type == 'roll_normal_invoice'">
        <van-field v-model="billData.invoiceCode" name="发票代码" label="发票代码" placeholder="发票代码"
                   :rules="[{ required: true, message: '请填写发票代码' }]"
        />
        <van-field v-model="billData.invoiceNum" name="发票号码" label="发票号码" placeholder="发票号码"
                   :rules="[{ required: true, message: '请填写发票号码' }]"
        />
        <van-field v-model="billData.invoiceDate" name="开票日期" label="开票日期" placeholder="开票日期"
                   :rules="[{ required: true, message: '请填写开票日期' }]"
        />
        <van-field v-model="billData.purchaserName" name="购方名称" label="购方名称" placeholder="购方名称"
                   :rules="[{ required: true, message: '请填写购方名称' }]"
        />
        <van-field v-model="billData.sellerName" name="销售方名称" label="销售方名称" placeholder="销售方名称"
                   :rules="[{ required: true, message: '请填写销售方名称' }]"
        />
        <van-field v-model="billData.sellerRegisterNum" name="销售方纳税人识别号" label="销售方纳税人识别号" placeholder="销售方纳税人识别号"
                   :rules="[{ required: true, message: '请填写销售方纳税人识别号' }]"
        />
        <van-field v-model="billData.totalTax" name="合计税额" label="合计税额" placeholder="合计税额" type="number" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写合计税额' }]"
        />
        <van-field v-model="billData.amountInWords" name="价税合计(大写)" label="价税合计(大写)" placeholder="价税合计(大写)"
                   :rules="[{ required: true, message: '请填写价税合计(大写)' }]"
        />
        <van-field v-model="billData.amountInFiguers" name="价税合计(小写)" label="价税合计(小写)" placeholder="价税合计(小写)" type="number" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写价税合计(小写)' }]"
        />
        <van-field v-model="billData.payee" name="收款人" label="收款人" placeholder="收款人"
                   :rules="[{ required: true, message: '请填写收款人' }]"
        />
        <van-field v-model="billData.province" name="省" label="省" placeholder="省"
                   :rules="[{ required: true, message: '请填写省' }]"
        />
        <van-field v-model="billData.city" name="市" label="市" placeholder="市"
        />
				<div class="tip">
					<div>发票明细</div>
          <van-button v-show="method === 'add'" icon="plus" type="info" size="small" @click="addDetail"></van-button>
				</div>
        <div class="list" v-for="(item,index) in billDetails" :key="index" @click="handerDetail(index,billDetails,billData.status,billData.ischeck)">
          <span class="item span">{{item.name}}</span>
          <div class="item-line"></div>
        </div>
			</div>
			<div v-if="type == 'printed_invoice'">
        <van-field v-model="billData.invoiceCode" name="发票代码" label="发票代码" placeholder="发票代码"
                   :rules="[{ required: true, message: '请填写发票代码' }]"
        />
        <van-field v-model="billData.invoiceNum" name="发票号码" label="发票号码" placeholder="发票号码"
                   :rules="[{ required: true, message: '请填写发票号码' }]"
        />
        <van-field v-model="billData.invoiceDate" name="开票日期" label="开票日期" placeholder="开票日期"
        />
        <van-field v-model="billData.amountInWords" name="价税合计(大写)" label="价税合计(大写)" placeholder="价税合计(大写)"
                   :rules="[{ required: true, message: '请填写价税合计(大写)' }]"
        />
        <van-field v-model="billData.amountInFiguers" name="价税合计(小写)" label="价税合计(小写)" placeholder="价税合计(小写)" type="number" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写价税合计(小写)' }]"
        />
        <van-field v-model="billData.sellerName" name="销售方名称" label="销售方名称" placeholder="销售方名称"
                   :rules="[{ required: true, message: '请填写销售方名称' }]"
        />
        <van-field v-model="billData.sellerRegisterNum" name="销售方纳税人识别号" label="销售方纳税人识别号" placeholder="销售方纳税人识别号"
                   :rules="[{ required: true, message: '请填写销售方纳税人识别号' }]"
        />
        <van-field v-model="billData.purchaserName" name="购方名称" label="购方名称" placeholder="购方名称"
                   :rules="[{ required: true, message: '请填写购方名称' }]"
        />
        <van-field v-model="billData.totalTax" name="合计税额" label="合计税额" placeholder="合计税额" type="number" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写合计税额' }]"
        />
        <van-field v-model="billData.province" name="省" label="省" placeholder="省"
                   :rules="[{ required: true, message: '请填写省' }]"
        />
        <van-field v-model="billData.city" name="市" label="市" placeholder="市"
        />
        <van-field v-model="billData.time" name="时间" label="时间" placeholder="时间"
        />
				<div class="tip">
					<div>发票明细</div>
          <van-button v-show="method === 'add'" icon="plus" type="info" size="small" @click="addDetail"></van-button>
				</div>
				<div class="list" v-for="(item,index) in billDetails" :key="index" @click="handerDetail(index,billDetails,billData.status,billData.ischeck)">
					<span class="item span">{{item.name}}</span>
					<div class="item-line"></div>
				</div>
			</div>
			<div v-if="type == 'bus_ticket'">
        <van-field v-model="billData.invoiceCode" name="发票代码" label="发票代码" placeholder="发票代码"
                   :rules="[{ required: true, message: '请填写发票代码' }]"
        />
        <van-field v-model="billData.invoiceNum" name="发票号码" label="发票号码" placeholder="发票号码"
                   :rules="[{ required: true, message: '请填写发票号码' }]"
        />
        <van-field v-model="billData.date" name="日期" label="日期" placeholder="日期"
                   :rules="[{ required: true, message: '请填写日期' }]"
        />
        <van-field v-model="billData.time" name="时间" label="时间" placeholder="时间"
                   :rules="[{ required: true, message: '请填写时间' }]"
        />
        <van-field v-model="billData.exitStation" name="出发站" label="出发站" placeholder="出发站"
                   :rules="[{ required: true, message: '请填写出发站' }]"
        />
        <van-field v-model="billData.arrivalStation" name="到达站" label="到达站" placeholder="到达站"
                   :rules="[{ required: true, message: '请填写到达站' }]"
        />
        <van-field v-model="billData.amount" name="金额" label="金额" placeholder="金额" type="number" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写金额' }]"
        />
        <van-field v-model="billData.name" name="姓名" label="姓名" placeholder="姓名"
                   :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field v-model="billData.idCard" name="身份证号" label="身份证号" placeholder="身份证号"
                   :rules="[{ required: true, message: '请填写身份证号' }]"
        />
        <van-field v-model="billData.invoiceTime" name="开票日期" label="开票日期" placeholder="开票日期"
                   :rules="[{ required: true, message: '请填写开票日期' }]"
        />
			</div>
			<div v-if="type == 'toll_invoice'">
        <van-field v-model="billData.invoiceCode" name="发票代码" label="发票代码" placeholder="发票代码"
                   :rules="[{ required: true, message: '请填写发票代码' }]"
        />
        <van-field v-model="billData.invoiceNum" name="发票号码" label="发票号码" placeholder="发票号码"
                   :rules="[{ required: true, message: '请填写发票号码' }]"
        />
        <van-field v-model="billData.entrance" name="入口" label="入口" placeholder="入口"
                   :rules="[{ required: true, message: '请填写入口' }]"
        />
        <van-field v-model="billData.exitus" name="出口" label="出口" placeholder="出口"
                   :rules="[{ required: true, message: '请填写出口' }]"
        />
        <van-field v-model="billData.outDate" name="日期" label="日期" placeholder="日期"
                   :rules="[{ required: true, message: '请填写日期' }]"
        />
        <van-field v-model="billData.outTime" name="时间" label="时间" placeholder="时间"
                   :rules="[{ required: true, message: '请填写时间' }]"
        />
        <van-field v-model="billData.totalAmount" name="金额" label="金额" placeholder="金额" type="number" :formatter="formatterNumber" format-trigger="onBlur"
        />
        <van-field v-model="billData.province" name="省" label="省" placeholder="省"
                   :rules="[{ required: true, message: '请填写省' }]"
        />
        <van-field v-model="billData.city" name="市" label="市" placeholder="市"
        />
			</div>
			<div v-if="type == 'ferry_ticket'">
        <van-field v-model="billData.invoiceCode" name="发票代码" label="发票代码" placeholder="发票代码"
                   :rules="[{ required: true, message: '请填写发票代码' }]"
        />
        <van-field v-model="billData.invoiceNum" name="发票号码" label="发票号码" placeholder="发票号码"
                   :rules="[{ required: true, message: '请填写发票号码' }]"
        />
        <van-field v-model="billData.exitStation" name="出发地点" label="出发地点" placeholder="出发地点"
                   :rules="[{ required: true, message: '请填写出发地点' }]"
        />
        <van-field v-model="billData.arrivalStation" name="到达地点" label="到达地点" placeholder="到达地点"
                   :rules="[{ required: true, message: '请填写到达地点' }]"
        />
        <van-field v-model="billData.amount" name="总金额" label="总金额" placeholder="总金额"
                   :rules="[{ required: true, message: '请填写总金额' }]"
        />
        <van-field v-model="billData.date" name="开票日期" label="开票日期" placeholder="开票日期"
                   :rules="[{ required: true, message: '请填写开票日期' }]"
        />
        <van-field v-model="billData.moneyType" name="金额类型" label="金额类型" placeholder="金额类型"
                   :rules="[{ required: true, message: '请填写金额类型' }]"
        />
			</div>
			<div v-if="type == 'motor_vehicle_invoice'">
        <van-field v-model="billData.purchaserName" name="购买方名称" label="购买方名称" placeholder="购买方名称"
                   :rules="[{ required: true, message: '请填写购买方名称' }]"
        />
        <van-field v-model="billData.purchaserRegisterNum" name="购买方税号" label="购买方税号" placeholder="购买方税号"
        />
        <van-field v-model="billData.sellerName" name="销售方名称" label="销售方名称" placeholder="销售方名称" autosize
                   type="textarea"
        />
        <van-field v-model="billData.sellerRegisterNum" name="销售方税号" label="销售方税号" placeholder="销售方税号"
        />
        <van-field v-model="billData.invoiceDate" name="开票日期" label="开票日期" placeholder="开票日期"
                   :rules="[{ required: true, message: '请填写开票日期' }]"
        />
        <van-field v-model="billData.invoiceCode" name="发票代码" label="发票代码" placeholder="发票代码"
                   :rules="[{ required: true, message: '请填写发票代码' }]"
        />
        <van-field v-model="billData.invoiceNum" name="发票号码" label="发票号码" placeholder="发票号码"
                   :rules="[{ required: true, message: '请填写发票号码' }]"
        />
        <van-field v-model="billData.printedCode" name="机打代码" label="机打代码" placeholder="机打代码"
                   :rules="[{ required: true, message: '请填写机打代码' }]"
        />
        <van-field v-model="billData.printedNum" name="机打号码" label="机打号码" placeholder="机打号码"
                   :rules="[{ required: true, message: '请填写机打号码' }]"
        />
        <van-field v-model="billData.carClass" name="车辆类型" label="车辆类型" placeholder="车辆类型"
                   :rules="[{ required: true, message: '请填写车辆类型' }]"
        />
        <van-field v-model="billData.carModel" name="厂牌型号" label="厂牌型号" placeholder="厂牌型号"
                   :rules="[{ required: true, message: '请填写厂牌型号' }]"
        />
        <van-field v-model="billData.productLocation" name="产地" label="产地" placeholder="产地"
                   :rules="[{ required: true, message: '请填写产地' }]"
        />
        <van-field v-model="billData.certificateNum" name="合格证号" label="合格证号" placeholder="合格证号"
                   :rules="[{ required: true, message: '请填写合格证号' }]"
        />
        <van-field v-model="billData.engineNum" name="发动机号码" label="发动机号码" placeholder="发动机号码"
                   :rules="[{ required: true, message: '请填写发动机号码' }]"
        />
        <van-field v-model="billData.vinNum" name="车架号码" label="车架号码" placeholder="车架号码"
                   :rules="[{ required: true, message: '请填写车架号码' }]"
        />
        <van-field v-model="billData.taxRate" name="税率" label="税率" placeholder="税率"
                   :rules="[{ required: true, message: '请填写税率' }]"
        />
        <van-field v-model="billData.tax" name="税额" label="税额" placeholder="税额" type="number" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写税额' }]"
        />
        <van-field v-model="billData.price" name="不含税价格" label="不含税价格" placeholder="不含税价格" type="number" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写不含税价格' }]"
        />
        <van-field v-model="billData.priceTaxBig" name="价税合计大写" label="价税合计大写" placeholder="价税合计大写"
                   :rules="[{ required: true, message: '请填写价税合计大写' }]"
        />
        <van-field v-model="billData.priceTaxSmall" name="价税合计小写" label="价税合计小写" placeholder="价税合计小写" type="number" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写价税合计小写' }]"
        />
        <van-field v-model="billData.salerPhone" name="销货单位电话" label="销货单位电话" placeholder="销货单位电话"
                   :rules="[{ required: true, message: '请填写销货单位电话' }]"
        />
        <van-field v-model="billData.salerBankNum" name="销货单位账号" label="销货单位账号" placeholder="销货单位账号"
                   :rules="[{ required: true, message: '请填写销货单位账号' }]"
        />
        <van-field v-model="billData.salerAddress" name="销货单位地址" label="销货单位地址" placeholder="销货单位地址" type="textarea" autosize
                   :rules="[{ required: true, message: '请填写销货单位地址' }]"
        />
        <van-field v-model="billData.salerBank" name="销货单位开户银行" label="销货单位开户银行" placeholder="销货单位开户银行"  type="textarea" autosize
                   :rules="[{ required: true, message: '请填写销货单位开户银行' }]"
        />
        <van-field v-model="billData.taxJiguan" name="主管税务机关" label="主管税务机关" placeholder="主管税务机关" type="textarea" autosize
                   :rules="[{ required: true, message: '请填写主管税务机关' }]"
        />
        <van-field v-model="billData.taxJiguanCode" name="主管税务机关代码" label="主管税务机关代码" placeholder="主管税务机关代码"
                   :rules="[{ required: true, message: '请填写主管税务机关代码' }]"
        />
        <van-field v-model="billData.limitMount" name="限乘人数" label="限乘人数" placeholder="限乘人数"
                   :rules="[{ required: true, message: '请填写限乘人数' }]"
        />
        <van-field v-model="billData.toonage" name="吨位" label="吨位" placeholder="吨位" type="number" :formatter="formatterNumber" format-trigger="onBlur"
        />
			</div>
			<div v-if="type == 'used_vehicle_invoice'">
        <van-field v-model="billData.invoiceDate" name="开票日期" label="开票日期" placeholder="开票日期"
                   :rules="[{ required: true, message: '请填写开票日期' }]"
        />
        <van-field v-model="billData.invoiceCode" name="发票代码" label="发票代码" placeholder="发票代码"
                   :rules="[{ required: true, message: '请填写发票代码' }]"
        />
        <van-field v-model="billData.invoiceNum" name="发票号码" label="发票号码" placeholder="发票号码"
                   :rules="[{ required: true, message: '请填写发票号码' }]"
        />
        <van-field v-model="billData.taxCode" name="税控码" label="税控码" placeholder="税控码"
        />
        <van-field v-model="billData.buyer" name="购买方名称" label="购买方名称" placeholder="购买方名称"
                   :rules="[{ required: true, message: '请填写购买方名称' }]"
        />
        <van-field v-model="billData.buyerIdCard" name="购买方身份证号" label="购买方身份证号" placeholder="购买方身份证号"
                   :rules="[{ required: true, message: '请填写购买方身份证号' }]"
        />
        <van-field v-model="billData.buyerStation" name="购买方地址" label="购买方地址" placeholder="购买方地址"
                   :rules="[{ required: true, message: '请填写购买方地址' }]"
        />
        <van-field v-model="billData.buyerTel" name="购买方电话" label="购买方电话" placeholder="购买方电话"
                   :rules="[{ required: true, message: '请填写购买方电话' }]"
        />
        <van-field v-model="billData.saler" name="卖方" label="卖方" placeholder="卖方"
                   :rules="[{ required: true, message: '请填写卖方' }]"
        />
        <van-field v-model="billData.salerIdCard" name="卖方身份证号" label="卖方身份证号" placeholder="卖方身份证号"
                   :rules="[{ required: true, message: '请填写卖方身份证号' }]"
        />
        <van-field v-model="billData.salerStation" name="卖方地址" label="卖方地址" placeholder="卖方地址"
                   :rules="[{ required: true, message: '请填写卖方地址' }]"
        />
        <van-field v-model="billData.salerTel" name="卖方电话" label="卖方电话" placeholder="卖方电话"
                   :rules="[{ required: true, message: '请填写卖方电话' }]"
        />
        <van-field v-model="billData.carPlate" name="车牌号" label="车牌号" placeholder="车牌号"
                   :rules="[{ required: true, message: '请填写车牌号' }]"
        />
        <van-field v-model="billData.carCertificate" name="登记证号" label="登记证号" placeholder="登记证号"
                   :rules="[{ required: true, message: '请填写登记证号' }]"
        />
        <van-field v-model="billData.carClass" name="车辆类型" label="车辆类型" placeholder="车辆类型"
                   :rules="[{ required: true, message: '请填写车辆类型' }]"
        />
        <van-field v-model="billData.vin_num" name="车架号" label="车架号" placeholder="车架号"
                   :rules="[{ required: true, message: '请填写车架号' }]"
        />
        <van-field v-model="billData.model" name="厂牌型号" label="厂牌型号" placeholder="厂牌型号"
                   :rules="[{ required: true, message: '请填写厂牌型号' }]"
        />
        <van-field v-model="billData.toStation" name="转入地车管所名称" label="转入地车管所名称" placeholder="转入地车管所名称"
                   :rules="[{ required: true, message: '请填写转入地车管所名称' }]"
        />
        <van-field v-model="billData.bigPrice" name="车价合计大写" label="车价合计大写" placeholder="车价合计大写"
                   :rules="[{ required: true, message: '请填写车价合计大写' }]"
        />
        <van-field v-model="billData.smallPrice" name="车价合计小写" label="车价合计小写" placeholder="车价合计小写" type="number" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写车价合计小写' }]"
        />
        <van-field v-model="billData.carMarket" name="二手车市场" label="二手车市场" placeholder="二手车市场"
                   :rules="[{ required: true, message: '请填写二手车市场' }]"
        />
        <van-field v-model="billData.taxNum" name="纳税人识别号" label="纳税人识别号" placeholder="纳税人识别号"
                   :rules="[{ required: true, message: '请填写纳税人识别号' }]"
        />
        <van-field v-model="billData.taxLocation" name="纳税人地址" label="纳税人地址" placeholder="纳税人地址"
                   :rules="[{ required: true, message: '请填写纳税人地址' }]"
        />
        <van-field v-model="billData.taxTel" name="纳税人电话" label="纳税人电话" placeholder="纳税人电话"
                   :rules="[{ required: true, message: '请填写纳税人电话' }]"
        />
			</div>
			<div v-if="type == 'taxi_online_ticket'">
        <van-field v-model="billData.serviceProvider" name="服务商" label="服务商" placeholder="服务商"
                   :rules="[{ required: true, message: '请填写服务商' }]"
        />
        <van-field v-model="billData.startTime" name="行程开始时间" label="行程开始时间" placeholder="行程开始时间"
                   :rules="[{ required: true, message: '请填写行程开始时间' }]"
        />
        <van-field v-model="billData.destinationTime" name="行程结束时间" label="行程结束时间" placeholder="行程结束时间"
                   :rules="[{ required: true, message: '请填写行程结束时间' }]"
        />
        <van-field v-model="billData.phone" name="行程人手机号" label="行程人手机号" placeholder="行程人手机号"
                   :rules="[{ required: true, message: '请填写行程人手机号' }]"
        />
        <van-field v-model="billData.applicationDate" name="申请日期" label="申请日期" placeholder="申请日期"
                   :rules="[{ required: true, message: '请填写申请日期' }]"
        />
        <van-field v-model="billData.totalFare" name="总金额" label="总金额" placeholder="总金额" type="number" :formatter="formatterNumber" format-trigger="onBlur"
                   :rules="[{ required: true, message: '请填写总金额' }]"
        />
				<div class="tip">
					<div>发票明细</div>
          <van-button v-show="method === 'add'" icon="plus" type="info" size="small" @click="addDetail"></van-button>
				</div>
				<div class="list" v-for="(item,index) in billDetails" :key="index" @click="handerDetail(index,billDetails,billData.status,billData.ischeck)">
					<span class="item span">{{item.startPlace}}</span>
					<div class="item-line"></div>
				</div>
			</div>
			
	<!--		<div v-if="(billData.url+'').indexOf('.jpg') != -1 || (billData.url+'').indexOf('.png') != -1">-->
				<!-- <van-uploader v-model="[url: billData.url, isImage: true]" multiple/> -->
	<!--		</div>-->
		</van-form>
		<van-popup v-model="showDetail" :closeable="true" :close-on-click-overlay="false" round position="bottom" :style="{ height: '80%' }" @close="cancelDetail">
			<InvoiceDetail ref="InvoiceDetail" @childSave="childSave" :edit="true"/>
		</van-popup>
		<div style="position:absolute; left: 0; bottom: 0; width: 100%; height: 50px">
		  <van-button size="large" type="info" @click="submitBill(0)">保存</van-button>
		</div>
	</div>

    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
          type="date"
          @confirm="onConfirm"
          @cancel="showDatePicker = false"
      />
    </van-popup>


    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
          show-toolbar
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
      />
    </van-popup>
	</div>
</template>

<script>
	import InvoiceService from '@/api/invoice/InvoiceService.js' ;
	import InvoiceDetail from './invoiceDetail.vue'
  import moment from 'moment'
  import Decimal from "decimal.js";
	
	export default {
	  name: 'invoiceInfo',
		data() {
			return {
				billData: {},
				billDetails:[],
				type: '',
				showDetail: false,
        showDatePicker: false,
        dateType: '',
        result: {},
        showPicker: false,
        columns: [
          {
            text: '增值税发票',
            type: 'vat_invoice'
          },
          {
            text: '出租车票',
            type: 'taxi_receipt'
          },
          {
            text: '火车票',
            type: 'train_ticket'
          },
          {
            text: '定额发票',
            type: 'quota_invoice'
          },
          {
            text: '飞机行程单',
            type: 'air_ticket'
          },
          {
            text: '卷票',
            type: 'roll_normal_invoice'
          },
          {
            text: '机打发票',
            type: 'printed_invoice'
          },
          {
            text: '汽车票',
            type: 'bus_ticket'
          },
          {
            text: '过路过桥费',
            type: 'toll_invoice'
          },
          {
            text: '船票',
            type: 'ferry_ticket'
          },
          {
            text: '机动车销售发票',
            type: 'motor_vehicle_invoice'
          },
          {
            text: '二手车销售发票',
            type: 'used_vehicle_invoice'
          },
          {
            text: '网约车行程单',
            type: 'taxi_online_ticket'
          },
        ],
        method: '',
        index: 0,
			}
		},
		components: {
			InvoiceDetail
		},
		created(){
      this.billData = JSON.parse(decodeURIComponent(this.$route.query.data)) ;
      this.result = JSON.parse(decodeURIComponent(this.$route.query.result)) ;
      localStorage.setItem('results', JSON.stringify(this.result))
      this.index = this.$route.query.index;
			if(this.$route.query.billDetails){
        // console.log(JSON.parse(decodeURIComponent(this.$route.query.billDetails)))
				let billDetails = JSON.parse(decodeURIComponent(this.$route.query.billDetails));
				if(!Array.isArray(billDetails)){
					this.billDetails[0] = billDetails;
				}else{
					this.billDetails = billDetails;
				}
			} else {
			  this.billDetails = [];
      }
			this.type = this.$route.query.type;
			this.method = this.$route.query.method
			if(this.type == ''){
				this.type = 'vat_invoice'
			}
			if( this.method === 'add') {
        this.type = 'vat_invoice'
        this.billData.typeName = '增值税发票'
      }

			if(this.type === 'ferry_ticket') {
        let regex = /^[0-9]+(\.[0-9]{1,2})?$/;
        if (!regex.test(this.billData.amount)) {
          this.billData.amount = 0.00
        }
      }
			// uni.removeStorageSync("detail");
		},
    activated() {
      this.billData = JSON.parse(decodeURIComponent(this.$route.query.data)) ;
      this.result = JSON.parse(decodeURIComponent(this.$route.query.result)) ;
      localStorage.setItem('results', JSON.stringify(this.result))
      this.index = this.$route.query.index;
      if(this.$route.query.billDetails){
        // console.log(JSON.parse(decodeURIComponent(this.$route.query.billDetails)))
        let billDetails = JSON.parse(decodeURIComponent(this.$route.query.billDetails));
        if(!Array.isArray(billDetails)){
          this.billDetails[0] = billDetails;
        }else{
          this.billDetails = billDetails;
        }
      } else {
        this.billDetails = [];
      }
      this.type = this.$route.query.type;
      this.method = this.$route.query.method
      if(this.type == ''){
        this.type = 'vat_invoice'
      }
      if( this.method === 'add') {
        this.type = 'vat_invoice'
        this.billData.typeName = '增值税发票'
      }

      if(this.type === 'ferry_ticket') {
        let regex = /^[0-9]+(\.[0-9]{1,2})?$/;
        if (!regex.test(this.billData.amount)) {
          this.billData.amount = 0.00
        }
      }
    },
    methods: {
			submitBill(cz){
				let _this = this;
				this.$dialog.confirm({
					message: '确定保存吗？',
				}).then((res) => {
					this.$toast.loading({
					  title:'正在提交...',
					  forbidClick: true,
					})
					//修改时用到=======开始========//
					// let detail = uni.getStorageSync("detail");
					// if(detail != ''){
					//   _this.billDetails = JSON.parse(detail);
					// }
					//修改时用到=======结束========//
          if(this.method === 'add') {
            if(this.type === 'vat_invoice' || this.type === 'roll_normal_invoice' || this.type === 'printed_invoice' || this.type === 'taxi_online_ticket') {
              if(this.billDetails.length === 0) {
                this.$toast.fail('请添加发票明细');
                return
              }

              if(this.type === 'vat_invoice' || this.type === 'roll_normal_invoice' || this.type === 'printed_invoice') {
                if(!this.billDetails[this.billDetails.length - 1].name) {
                  this.$toast.fail('请完善发票明细');
                  return
                }
              }
              if(this.type === 'taxi_online_ticket') {
                if(!this.billDetails[this.billDetails.length - 1].pickupDate) {
                  this.$toast.fail('请完善发票明细');
                  return
                }
              }
            }
            new InvoiceService().editBill({
              bill:JSON.stringify(_this.billData),
              billDetails:JSON.stringify(_this.billDetails),
              type:_this.type,
            }).then((res)=>{
              this.$toast.success(_this.billData.status == 0?'修改成功':res.data.msg);
              setTimeout(() => {
                this.$router.back()
              }, 800)
            }).catch((e)=>{
              this.$toast.fail((_this.billData.status == 0 && res.data.msg == '')?'保存失败，请勿输入非法字符':res.data.msg);
            })

            return
          }
          switch (_this.type) {
					  case 'vat_invoice':
					    this.result[this.index] = {
                code: this.result[this.index].code,
                errorMsg: this.result[this.index].errorMsg,
                msg: this.result[this.index].msg,
                selected: this.result[this.index].selected,
                vatInvoice: _this.billData,
                vatInvoiceDetails: _this.billDetails,
                type: this.result[this.index].type,
              }
              localStorage.setItem('results', JSON.stringify(this.result))
              this.$toast.success('修改成功')
              setTimeout(() => {
                this.$router.back()
              }, 800)
                  break;
              case 'taxi_receipt':
                let isCheck = this.checkAmount('taxi_receipt',this.billData.fare,this.billData.fuelOilSurcharge,this.billData.callServiceSurcharge,this.billData.totalFare)
                  if(!isCheck) {
                    this.$toast.fail('金额之和错误')
                    return
                  }
                this.result[this.index] = {
                  code: this.result[this.index].code,
                  errorMsg: this.result[this.index].errorMsg,
                  msg: this.result[this.index].msg,
                  selected: this.result[this.index].selected,
                  taxiReceipt: _this.billData,
                  type: this.result[this.index].type,
                }
                localStorage.setItem('results', JSON.stringify(this.result))
                this.$toast.success('修改成功')
                setTimeout(() => {
                  this.$router.back()
                }, 800)
                break;
            case 'train_ticket':
              this.result[this.index] = {
                code: this.result[this.index].code,
                errorMsg: this.result[this.index].errorMsg,
                msg: this.result[this.index].msg,
                selected: this.result[this.index].selected,
                trainTicket: _this.billData,
                type: this.result[this.index].type,
              }
              localStorage.setItem('results', JSON.stringify(this.result))
              // localStorage.setItem('results', JSON.stringify([{
              //   code: this.result.code,
              //   errorMsg: this.result.errorMsg,
              //   msg: this.result.msg,
              //   selected: this.result.selected,
              //   trainTicket: _this.billData,
              //   type: this.result.type,
              // }]))
              this.$toast.success('修改成功')
              setTimeout(() => {
                this.$router.back()
              }, 800)
              break;
            case 'quota_invoice':
              this.result[this.index] = {
                code: this.result[this.index].code,
                errorMsg: this.result[this.index].errorMsg,
                msg: this.result[this.index].msg,
                selected: this.result[this.index].selected,
                quotaInvoice: _this.billData,
                type: this.result[this.index].type,
              }
              localStorage.setItem('results', JSON.stringify(this.result))
              // localStorage.setItem('results', JSON.stringify([{
              //   code: this.result.code,
              //   errorMsg: this.result.errorMsg,
              //   msg: this.result.msg,
              //   selected: this.result.selected,
              //   quotaInvoice: _this.billData,
              //   type: this.result.type,
              // }]))
              this.$toast.success('修改成功')
              setTimeout(() => {
                this.$router.back()
              }, 800)
              break;
            case 'air_ticket':
              let isAirCheck = this.checkAmount('air_ticket',this.billData.devFund,this.billData.oilMoney,this.billData.fare,this.billData.otherTax,this.billData.ticketRates)
              if(!isAirCheck) {
                this.$toast.fail('金额之和错误')
                return
              }
              this.result[this.index] = {
                code: this.result[this.index].code,
                errorMsg: this.result[this.index].errorMsg,
                msg: this.result[this.index].msg,
                selected: this.result[this.index].selected,
                airTicket: _this.billData,
                type: this.result[this.index].type,
              }
              localStorage.setItem('results', JSON.stringify(this.result))
              // localStorage.setItem('results', JSON.stringify([{
              //   code: this.result.code,
              //   errorMsg: this.result.errorMsg,
              //   msg: this.result.msg,
              //   selected: this.result.selected,
              //   airTicket: _this.billData,
              //   type: this.result.type,
              // }]))
              this.$toast.success('修改成功')
              setTimeout(() => {
                this.$router.back()
              }, 800)
              break;
            case 'roll_normal_invoice':
              this.result[this.index] = {
                code: this.result[this.index].code,
                errorMsg: this.result[this.index].errorMsg,
                msg: this.result[this.index].msg,
                selected: this.result[this.index].selected,
                rollNormalInvoice: _this.billData,
                rollNormalInvoiceDetails: _this.billDetails,
                type: this.result[this.index].type,
              }
              localStorage.setItem('results', JSON.stringify(this.result))
              // localStorage.setItem('results', JSON.stringify([{
              //   code: this.result.code,
              //   errorMsg: this.result.errorMsg,
              //   msg: this.result.msg,
              //   selected: this.result.selected,
              //   rollNormalInvoice: _this.billData,
              //   rollNormalInvoiceDetails: _this.billDetails,
              //   type: this.result.type,
              // }]))
              this.$toast.success('修改成功')
              setTimeout(() => {
                this.$router.back()
              }, 800)
              break;
            case 'printed_invoice':
              this.result[this.index] = {
                code: this.result[this.index].code,
                errorMsg: this.result[this.index].errorMsg,
                msg: this.result[this.index].msg,
                selected: this.result[this.index].selected,
                printedInvoice: _this.billData,
                printedInvoiceDetails: _this.billDetails,
                type: this.result[this.index].type,
              }
              localStorage.setItem('results', JSON.stringify(this.result))
              // localStorage.setItem('results', JSON.stringify([{
              //   code: this.result.code,
              //   errorMsg: this.result.errorMsg,
              //   msg: this.result.msg,
              //   selected: this.result.selected,
              //   printedInvoice: _this.billData,
              //   printedInvoiceDetails: _this.billDetails,
              //   type: this.result.type,
              // }]))
              this.$toast.success('修改成功')
              setTimeout(() => {
                this.$router.back()
              }, 800)
              break;
            case 'bus_ticket':
              this.result[this.index] = {
                code: this.result[this.index].code,
                errorMsg: this.result[this.index].errorMsg,
                msg: this.result[this.index].msg,
                selected: this.result[this.index].selected,
                busTicket: _this.billData,
                type: this.result[this.index].type,
              }
              localStorage.setItem('results', JSON.stringify(this.result))
              // localStorage.setItem('results', JSON.stringify([{
              //   code: this.result.code,
              //   errorMsg: this.result.errorMsg,
              //   msg: this.result.msg,
              //   selected: this.result.selected,
              //   busTicket: _this.billData,
              //   type: this.result.type,
              // }]))
              this.$toast.success('修改成功')
              setTimeout(() => {
                this.$router.back()
              }, 800)
              break;
              case 'toll_invoice':
                this.result[this.index] = {
                  code: this.result[this.index].code,
                  errorMsg: this.result[this.index].errorMsg,
                  msg: this.result[this.index].msg,
                  selected: this.result[this.index].selected,
                  tollInvoice: _this.billData,
                  type: this.result[this.index].type,
                }
                localStorage.setItem('results', JSON.stringify(this.result))
                // localStorage.setItem('results', JSON.stringify([{
                //   code: this.result.code,
                //   errorMsg: this.result.errorMsg,
                //   msg: this.result.msg,
                //   selected: this.result.selected,
                //   tollInvoice: _this.billData,
                //   type: this.result.type,
                // }]))
                this.$toast.success('修改成功')
                setTimeout(() => {
                  this.$router.back()
                }, 800)
                break;
            case 'ferry_ticket':
              this.result[this.index] = {
                code: this.result[this.index].code,
                errorMsg: this.result[this.index].errorMsg,
                msg: this.result[this.index].msg,
                selected: this.result[this.index].selected,
                ferryTicket: _this.billData,
                type: this.result[this.index].type,
              }
              localStorage.setItem('results', JSON.stringify(this.result))
              // localStorage.setItem('results', JSON.stringify([{
              //   code: this.result.code,
              //   errorMsg: this.result.errorMsg,
              //   msg: this.result.msg,
              //   selected: this.result.selected,
              //   ferryTicket: _this.billData,
              //   type: this.result.type,
              // }]))
              this.$toast.success('修改成功')
              setTimeout(() => {
                this.$router.back()
              }, 800)
              break;
            case 'motor_vehicle_invoice':
                let isMotorCheck = this.checkAmount('motor_vehicle_invoice',this.billData.tax,this.billData.price,this.billData.priceTaxSmall)
                if(!isMotorCheck) {
                  this.$toast.fail('金额之和错误')
                  return
                }
              this.result[this.index] = {
                code: this.result[this.index].code,
                errorMsg: this.result[this.index].errorMsg,
                msg: this.result[this.index].msg,
                selected: this.result[this.index].selected,
                motorVehicleInvoice: _this.billData,
                type: this.result[this.index].type,
              }
              localStorage.setItem('results', JSON.stringify(this.result))
              // localStorage.setItem('results', JSON.stringify([{
              //   code: this.result.code,
              //   errorMsg: this.result.errorMsg,
              //   msg: this.result.msg,
              //   selected: this.result.selected,
              //   motorVehicleInvoice: _this.billData,
              //   type: this.result.type,
              // }]))
              this.$toast.success('修改成功')
              setTimeout(() => {
                this.$router.back()
              }, 800)
              break;
            case 'used_vehicle_invoice':
              this.result[this.index] = {
                code: this.result[this.index].code,
                errorMsg: this.result[this.index].errorMsg,
                msg: this.result[this.index].msg,
                selected: this.result[this.index].selected,
                usedVehicleInvoice: _this.billData,
                type: this.result[this.index].type,
              }
              localStorage.setItem('results', JSON.stringify(this.result))
              // localStorage.setItem('results', JSON.stringify([{
              //   code: this.result.code,
              //   errorMsg: this.result.errorMsg,
              //   msg: this.result.msg,
              //   selected: this.result.selected,
              //   usedVehicleInvoice: _this.billData,
              //   type: this.result.type,
              // }]))
              this.$toast.success('修改成功')
              setTimeout(() => {
                this.$router.back()
              }, 800)
              break;
            case 'taxi_online_ticket':
              this.result[this.index] = {
                code: this.result[this.index].code,
                errorMsg: this.result[this.index].errorMsg,
                msg: this.result[this.index].msg,
                selected: this.result[this.index].selected,
                taxiOnlineTicket: _this.billData,
                items: _this.billDetails,
                type: this.result[this.index].type,
              }
              localStorage.setItem('results', JSON.stringify(this.result))
              // localStorage.setItem('results', JSON.stringify([{
              //   code: this.result.code,
              //   errorMsg: this.result.errorMsg,
              //   msg: this.result.msg,
              //   selected: this.result.selected,
              //   taxiOnlineTicket: _this.billData,
              //   items: _this.billDetails,
              //   type: this.result.type,
              // }]))
              this.$toast.success('修改成功')
              setTimeout(() => {
                this.$router.back()
              }, 800)
              break;
          }
				},)
			},
			handerDetail(index, item,status,ischeck){
				this.showDetail = true
				this.$nextTick(() => {
					this.$refs.InvoiceDetail.init(this.type, index, encodeURIComponent(JSON.stringify(item)), false)
				});
				// this.$router.push({
				// 	path: '/invoiceDetail',
				// 	query: {
				// 		type: this.type,
				// 		data: encodeURIComponent(JSON.stringify(item)),
				// 		index: index
				// 	}
				// })
			},
      addDetail(){
			  switch (this.type) {
            case 'vat_invoice':
              this.billDetails.push({
                detailno: '',
                name: '',
                type: '',
                unit: '',
                num: '',
                price: '',
                amount: '',
                taxRate: '',
                tax: ''
              })
              break
          case 'roll_normal_invoice':
            this.billDetails.push({
              name: '',
              num: '',
              price: '',
              amount: '',
            })
            break
          case 'printed_invoice':
            this.billDetails.push({
              name: '',
              unit: '',
              num: '',
              price: '',
              amount: '',
            })
            break
          case 'taxi_online_ticket':
            this.billDetails.push({
              pickupDate: '',
              pickupTime: '',
              carType: '',
              distance: '',
              startPlace: '',
              destinationPlace: '',
              city: '',
              fare: ''
            })
            break
        }

        this.showDetail = true
        this.$nextTick(() => {
          this.$refs.InvoiceDetail.init(this.type, this.billDetails.length - 1, encodeURIComponent(JSON.stringify(this.billDetails)), false)
        });
      },
			checkAmount(type,amount1, amount2, amount3, amount4, amount5){
        if(amount1 === undefined) {
          amount1 = 0
        }
        if(amount2 === undefined) {
          amount2 = 0
        }
        if(amount3 === undefined) {
          amount3 = 0
        }
        if(amount4 === undefined) {
          amount4 = 0
        }
        if(amount5 === undefined) {
          amount5 = 0
        }
				// console.log(parseFloat(amount1),parseFloat(amount2),parseFloat(amount3),parseFloat(amount4))
				if(type == 'vat_invoice' || type == 'motor_vehicle_invoice'){
				  return new Decimal(amount1).add(amount2).toFixed(2, Decimal.ROUND_HALF_UP) === new Decimal(amount3).toFixed(2, Decimal.ROUND_HALF_UP);
					// if((parseFloat(amount1.replace('￥','').replace('¥','')) + parseFloat(amount2.replace('￥','').replace('¥',''))) != parseFloat(amount3.replace('￥','').replace('¥',''))){
          //   return false
					// } else {
          //   return true
          // }
				}else if(type == 'air_ticket'){
				  return new Decimal(amount1).add(amount2).add(amount3).add(amount4).toFixed(2, Decimal.ROUND_HALF_UP) === new Decimal(amount5).toFixed(2, Decimal.ROUND_HALF_UP);
					// if((parseFloat(amount1.replace('￥','').replace('¥','')) + parseFloat(amount2.replace('￥','').replace('¥','')) + parseFloat(amount3.replace('￥','').replace('¥','')) + parseFloat(amount4.replace('￥','').replace('¥',''))) != parseFloat(amount5.replace('￥','').replace('¥',''))){
          //   return false
					// } else {
          //   return true
          // }
				}else if(type == 'taxi_receipt'){
				  return new Decimal(amount1).add(amount2).add(amount3).toFixed(2, Decimal.ROUND_HALF_UP) === new Decimal(amount4).toFixed(2, Decimal.ROUND_HALF_UP);
					// if((parseFloat(amount1.replace('￥','').replace('¥','')) + parseFloat(amount2.replace('￥','').replace('¥','')) + parseFloat(amount3.replace('￥','').replace('¥',''))) != parseFloat(amount4.replace('￥','').replace('¥',''))){
          //   return false
					// } else {
					//   return true
          // }
				}
			},
			childSave(index, billDetail){
				this.showDetail = false
				this.billData.type = this.type
				this.billDetails[index] = billDetail
        // console.log(billDetail)
			},
      cancelDetail(){
        this.showDetail = false
        if(this.method === 'add') {
          if(this.type === 'vat_invoice' || this.type === 'roll_normal_invoice' || this.type === 'printed_invoice') {
             if(this.billDetails[this.billDetails.length - 1].name) {
               return
             }
          }
          if(this.type === 'taxi_online_ticket') {
            if(this.billDetails[this.billDetails.length - 1].pickupDate) {
              return
            }
          }
          this.billDetails.splice(this.billDetails.length - 1, 1)
        }
      },
      openDatePicker(dateType){
			  this.showDatePicker = true
        this.dateType = dateType
      },
      onConfirm(data) {
        this.$refs.form.resetValidation()
        this.billData.typeName = data.text
        this.billDetails = []
        this.type = data.type
        this.showPicker = false
      },
      formatterNumber(value){
        return Number(value).toFixed(2)
      },
      changeAmount(){
        let bigAmount = this.numberToChinese(this.billData.invoiceRateInFigure)
        this.billData.invoiceRate = bigAmount
        this.billData.invoiceRateInWord = bigAmount
      },
      // 将数字转为大写
      numberToChinese(Amount) {
        if (Amount === 0) {
          return '零圆'
        }
        let amount = Math.abs(Amount)
        let tempAmount = ''
        if (amount !== '' && amount != null && amount !== '0') {
          let unit = '仟佰拾亿仟佰拾万仟佰拾圆角分'
          let str = ''
          amount += '00'
          const point = amount.indexOf('.')
          if (point >= 0) {
            amount = amount.substring(0, point) + amount.substr(point + 1, 2)
          }
          unit = unit.substr(unit.length - amount.length)
          for (let i = 0; i < amount.length; i++) {
            str += '零壹贰叁肆伍陆柒捌玖'.charAt(amount.charAt(i)) + unit.charAt(i)
          }
          tempAmount = str.replace(/零(仟|佰|拾|角)/g, '零')
              .replace(/(零)+/g, '零')
              .replace(/零(万|亿|圆)/g, '$1')
              .replace(/(亿)万|(拾)/g, '$1$2')
              .replace(/^圆零?|零分/g, '')
              .replace(/元$/g, '圆');
        }
        if (Amount < 0) {
          tempAmount = '负' + tempAmount
        }
        return tempAmount;
      },
		}
	}
</script>

<style scoped>
	page{
		background-color: #FFFFFF;
	}
	.content{
		width: 100%;
		padding-bottom: 50px;
		/*position: relative;*/
	}
	.tip{
		padding: 5px 10px;
		background-color: #EEEEEE;
		font-weight: bold;
    display: flex;
    /*flex-direction: column;*/
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
	}
	.row{
		display: flex;
		align-items: center;
		padding:0 10px;
		height: 35px;
		background-color: #FFFFFF;
		border-bottom: 1px solid #EEEEEE;
	}

  .tit{
    width: 115px;
    font-size: 15px;
    color: #000000;
  }
	.list{
		padding: 5px;
		position: relative;
		background-color: #FFFFFF;
  }
  .item{
    font-size: 15px;
    color: #303133;
    display: inline-block;
    margin-left: 5px;
  }
  .item-line {
    position: absolute;
    bottom: 0;
    left:0;
    height: 1px;
    width: 100%;
    background-color: #eeeeee;
  }
  .span{
    color: #0000FF;
  }
</style>

<style>
.van-picker-column__wrapper {
  padding: 0!important;
}
</style>
